import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalContentFn = /* @__PURE__ */ createRecipe('modal-content', {}, [])

const modalContentVariantMap = {}

const modalContentVariantKeys = Object.keys(modalContentVariantMap)

export const modalContent = /* @__PURE__ */ Object.assign(memo(modalContentFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalContent',
  __getCompoundVariantCss__: modalContentFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalContentVariantKeys,
  variantMap: modalContentVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalContentVariantKeys)
  },
  getVariantProps: modalContentFn.getVariantProps,
})